import React from 'react';

const ResponseFormComponent = () => {
  return <>Under development!!</>;
};

export default ResponseFormComponent;
